<template>
	<div class='modal-container' v-if='visible'>
		<div class='modal' v-if='gameState === "level-select"'>
			<h3>目隠しスライドパズル レベル選択</h3>
			<ul>
				<li v-on:click='$emit("memorizeStart", "open")'>
					<img src='../assets/open.svg' /> 隠さない
				</li>
				<li v-on:click='$emit("memorizeStart", "even")'>
					<img src='../assets/even.svg' /> 半分を隠す
				</li>
				<li v-on:click='$emit("memorizeStart","hidden")'>
					<img src='../assets/hidden.svg' /> すべて隠す
				</li>
			</ul>
		</div>
		<div class='modal' v-if='gameState === "finish" || gameState === "giveup"'>
			<h3 v-if='gameState === "finish"'>クリア！</h3>
			<h3 v-if='gameState === "giveup"'>ギブアップ！</h3>
			<ul>
				<li v-on:click='$emit("retry")'>
					<img src='../assets/retry.svg' /> もう一度
				</li>
				<li v-on:click='$emit("level-change")'>
					<img src='../assets/open.svg' />レベル変更
				</li>
				<li v-on:click='$emit("tweet")'>
					<img src='../assets/tweet.svg' /> ツイートする
				</li>
			</ul>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'Modal',
	props: {
		gameState: String
	},
	computed: {
		visible: function() {
			if (this.gameState === 'level-select') return true
			if (this.gameState === 'finish') return true
			if (this.gameState === 'giveup') return true
			return false
		}
	},
})
</script>

<style scoped>
.modal-container {
	position: absolute;
	top: 0px;
	left: 0px; /* Board マージン分ずれるので要修正 */
	width: 600px;
	height: 600px;
	color: #ffffff;
}

.modal {
	width: 66%;
	background-color: rgba(32, 32, 32, 0.75);
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	border-radius: 15px;
	padding: 20px;
}

ul {
	list-style: none;
}

li {
	padding: 10px;
	opacity: 0.7;
	cursor: pointer;
}

li:hover {
	opacity: 1;
}



* {
	font-size: 24px;
}
</style>